export default {
  search: {
    placeholder: 'Поиск товаров...',
    button: 'Найти',
    photo: 'Поиск по фото',
  },
  suggest: {
    history: 'История',
    category: 'Категория',
    brand: 'Бренд',
    article: 'Артикул',
    product: 'Товар',
  },
  filters: {
    title: 'Фильтры',
    category: 'Категория',
    gender: 'Пол',
    color: 'Цвет',
    size: 'Размер',
    price: 'Цена',
    priceFrom: 'от',
    priceTo: 'до',
    reset: 'Сбросить фильтры',
    apply: 'Применить',
    clear: 'Очистить',
  },
  results: {
    found: 'Найдено {count} {count, plural, one{товар} few{товара} many{товаров} other{товаров}}',
    notFound: 'Ничего не найдено',
    notFoundHint: 'Попробуйте изменить запрос или сбросить фильтры',
  },
  crop: {
    search: 'Искать похожие',
    cancel: 'Отмена',
    hint: 'Выделите область на изображении',
  },
  error: {
    title: 'Произошла ошибка',
    text: 'Не удалось загрузить результаты. Попробуйте позже.',
    retry: 'Повторить',
  },
  panel: {
    close: 'Закрыть',
  },
};
